import { render, staticRenderFns } from "./TrashConfig.vue?vue&type=template&id=35aa619c&scoped=true"
import script from "./TrashConfig.vue?vue&type=script&lang=ts"
export * from "./TrashConfig.vue?vue&type=script&lang=ts"
import style0 from "./TrashConfig.vue?vue&type=style&index=0&id=35aa619c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aa619c",
  null
  
)

export default component.exports